<template>
  <v-container fluid>
    <v-card>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field v-model="firstName" label="First Name" :rules="nameRules" required></v-text-field>
          <v-text-field v-model="lastName" label="Last Name" :rules="nameRules" required></v-text-field>
          <v-text-field v-model="email" label="Email" :rules="emailRules" required></v-text-field>
          <v-text-field
            v-model="password"
            :counter="6"
            label="Password"
            :rules="passwordRules"
            required
            type="password"
          ></v-text-field>
          <v-text-field
            v-model="passwordConfirm"
            :counter="6"
            label="Confirm Password"
            :rules="passwordConfirmRule"
            required
            type="password"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn class="mr-4" @click="registerByEmailLocal">Register</v-btn>
        <router-link to="/login">
          <a>Login</a>
        </router-link>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      valid: false,
      email: "",
      firstName: "",
      lastName: "",
      password: "",
      passwordConfirm: "",
      isLoading: false,
      nameRules: [v => !!v || "Name is required"],
      passwordRules: [
        v => !!v || "Password is required",
        v => (v && v.length >= 6) || "Passowrd must be at least 6 characters"
      ],
      passwordConfirmRule: [
        () => this.password === this.passwordConfirm || "Password must match"
      ],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ]
    };
  },
  methods: {
    ...mapActions(["clearMessage", "addMessage", "register"]),
    registerByEmailLocal() {
      if(!this.$refs.form.validate()){
        this.addMessage('Please check your input');
        return;
      }

      // const data = {
      //   email: this.email,
      //   firstName: this.firstName,
      //   lastName: this.lastName,
      //   password: this.password,
      // };
      
      
    }
  }
};
</script>
